import { BInputGroup } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBInputGroup = createEgBootstrapProxy(
  "EgBInputGroup",
  BInputGroup
);
